<template>
<div class="card">
  <div class="card-header">
    <h4 class="card-title"><i class="ti-user"></i> Clientes ({{ this.ticketsFiltered.length }})</h4>
  </div>
  <div class="card-content">
    <div
      class="row"
      style="margin-bottom: 20px;"
    >

      <div class="col-xs-1">
        <input
          v-if="$can('survey.associate')"
          type="checkbox"
          class="btn-large"
          @change="clickCheckAllTickets()"
          ref="checkAllTicket"
          style="margin: 0px 10px 0px 15px;"
        >
      </div>

      <div class="col-lg-8 col-xs-11">
        <strong>Selecionar todos</strong>
      </div>

      <div class="col-lg-2 col-xs-12"><strong>Usuário</strong></div>
      <div class="col-lg-1 col-xs-12"><strong>Ações</strong></div>
    </div>


    <div
      class="row"
      v-for="(ticket, index) in ticketsFiltered"
      :key="index"
      style="margin-bottom: 20px;"
    >
      <div
        class="col-xs-1"
        style="float: left;"
      >
        <input
          :ref="`ref-${ticket._id}`"
          v-if="!surveysFound(ticket)"
          @change="clickCheckTicket(ticket._id)"
          type="checkbox"
          style="float: left; margin: 15px;"
        >
      </div>

      <div class="col-lg-7 col-xs-11">
        <survey-customer-content
          v-if="customers[ticket.customerId]"
          :customer="customers[ticket.customerId]"
        ></survey-customer-content>
      </div>

      <div class="col-lg-1 col-xs-12">
        <survey-status-icons
          v-if="surveysFound(ticket)"
          :ticket="ticket"
          :survey="surveys[ticket._id]"
        ></survey-status-icons>
      </div>

      <div class="col-lg-2 col-xs-12">{{ getUserAssociated(ticket._id) }}</div>

      <div class="col-lg-1 col-xs-12">
        <survey-customer-actions
          :ticket="ticket"
          :survey="surveys[ticket._id]"
        ></survey-customer-actions>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import SurveyStatusIcons from './SurveyStatusIcons'
import UsersOptions from 'src/components/UsersOptions'
import SurveyCustomerActions from './SurveyCustomerActions'
import SurveyCustomerContent from './SurveyCustomerContent'
import { mapGetters } from 'vuex'

export default {
  name: 'survey-tickets-list-to-associate',

  props: {
    filters: {
      required: true,
      default: {
        status: [],
        neighborhood: [],
        users: []
      }
    },
    clean: {
      default: 1
    },
    surveysProp: {
      required: true,
      default: {}
    },
    tickets: { required: true },
    customers: { required: true }
  },

  components: {
    UsersOptions,
    SurveyCustomerContent,
    SurveyCustomerActions,
    SurveyStatusIcons
  },

  data () {
    return {
      indexTicketsChosen: []
    }
  },

  computed: {
    ...mapGetters('users', {
      users: 'users'
    }),

    surveys () {
      return this.surveysProp.reduce((acc, curr, index) => {
        if (index === 0) {
          acc = {}
        }
        acc[curr.ticketId] = curr
        return acc
      }, {})
    },

    ticketsFiltered () {
      return this.tickets.filter(ticket => {
        let surveyFound = this.surveys[ticket._id]
        let ifFilterAssociate = true
        let ifFilterNotAssociated = true
        let ifFilterSurveyed = true
        let ifFilterNotSurveyed = true
        let ifFilterNeighborhood = true
        let ifFilterUsers = true

        if (this.filters.hasOwnProperty('status')) {
          if (this.filters.status.indexOf('associated') !== -1) {
            ifFilterAssociate = ticket.surveyAssociated
          }
          if (this.filters.status.indexOf('notAssociated') !== -1) {
            ifFilterNotAssociated = !ticket.surveyAssociated
          }
          if (this.filters.status.indexOf('surveyed') !== -1) {
            ifFilterSurveyed = surveyFound && surveyFound.hasOwnProperty('data') && [
              'FINISHED',
              'SYNCED'
            ].indexOf(surveyFound.status) !== -1
          }
          if (this.filters.status.indexOf('notSurveyed') !== -1) {
            ifFilterNotSurveyed = !surveyFound || surveyFound.status === 'TODO'
          }
        }
        if (this.filters.hasOwnProperty('neighborhood')) {
          ifFilterNeighborhood = this.filters.neighborhood.length === 0 || this.filters.neighborhood.indexOf(this.customers[ticket.customerId].address.neighborhood) !== -1
        }
        if (this.filters.hasOwnProperty('users')) {
          ifFilterUsers = this.filters.users.length === 0 || this.filters.users.indexOf(surveyFound.user._id) !== -1
        }

        return ifFilterAssociate && ifFilterNotAssociated && ifFilterSurveyed && ifFilterNotSurveyed && ifFilterNeighborhood && ifFilterUsers
      })
    }
  },

  watch: {
    filters () {
      this.cleanCheckboxes()
    },
    clean () {
      this.cleanCheckboxes()
    }
  },

  methods: {
    emitSurveyDocuments () {
      this.$emit('surveyDocuments', this.createNewSurveyDocuments())
    },

    createNewSurveyDocuments () {
      return this.tickets.filter((item) => {
        return this.indexTicketsChosen.indexOf(item._id) >= 0
      }).map(ticket => {
        return this.createNewSurveyDocument(ticket)
      })
    },

    createNewSurveyDocument (ticket) {
      return {
        ticket,
        ticketId: ticket._id,
        customer: this.mapCustomerFromTicket(this.customers[ticket.customerId]),
        data: {},
        status: 'TODO'
      }
    },

    mapCustomerFromTicket (customer) {
      return {
        _id: customer._id,
        holder: customer.holder,
        uc: customer.uc,
        cpf: customer.cpf,
        nationalId: customer.nationalId,
        address: customer.address,
        phones: customer.phones
      }
    },

    clickCheckTicket (id) {
      let index = `ref-${id}`
      if (this.$refs[index]) {
        if (this.$refs[index][0].checked) {
          this.indexTicketsChosen.push(id)
        } else {
          this.indexTicketsChosen.splice(this.indexTicketsChosen.indexOf(id), 1)
        }
        this.emitSurveyDocuments()
      }
    },

    clickCheckAllTickets () {
      this.$nextTick(() => {
        if (this.$refs.checkAllTicket.checked) {
          this.checkAllBoxs()
        } else {
          this.cleanCheckboxes()
        }
        this.emitSurveyDocuments()
      })
    },

    getUserAssociated (ticketId) {
      let survey = this.surveys[ticketId]
      if (!survey) {
        return '-'
      }
      const user = this.users.find(function (item) {
        return item._id === survey.user._id
      })
      return user ? user.name : '-'
    },

    cleanCheckboxes () {
      this.indexTicketsChosen = []
      this.$refs.checkAllTicket.checked = false
      this.checkAllBoxs()
    },

    checkAllBoxs () {
      this.indexTicketsChosen = []
      for (let ticket of this.ticketsFiltered) {
        let index = `ref-${ticket._id}`
        if (this.$refs[index] && this.$refs[index][0]) {
          if (this.$refs.checkAllTicket.checked) {
            this.indexTicketsChosen.push(ticket._id)
          }
          this.$refs[index][0].checked = this.$refs.checkAllTicket.checked
        }
      }
    },

    surveysFound (ticket) {
      let survey = this.surveys[ticket._id]
      return survey && (survey.status === 'SYNCED' || survey.status === 'FINISHED')
    }
  }
}
</script>

<style scoped>
  input[type=checkbox] {
    transform: scale(1.2);
  }
</style>



// WEBPACK FOOTER //
// src/pages/Surveys/SurveyTicketsListToAssociate.vue